import { nameof } from "utils/nameof";
import { type CommonComponentProps } from "features/Library/Common/props";
import { type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import { Checkbox } from "features/Library/Common/QuestionsForm/Questions/QuestionFields/CheckBox/Checkbox";
import React from "react";

export interface RequiredToggleProps extends CommonComponentProps {
  question: SurveyQuestion<any>;
}

export const RequiredToggle = (props: RequiredToggleProps) => {
  const { validatedFieldProps, question, propertyNamePrefix, onChanged, disabled } = props;

  const disableToggle = !!question.isBranching;

  return (
    <Checkbox
      validatedFieldProps={validatedFieldProps}
      label={"Required"}
      onChanged={onChanged}
      propertyName={`${propertyNamePrefix}${nameof("isRequired")}`}
      isChecked={!!question.isRequired}
      tooltip={"Be sure to provide the answers."}
      disabled={disabled || disableToggle}
    />
  );
};
